const premiumProxiesLocation = `{
  "premium_proxies": true,
  "country": "gb"
}`;

export default premiumProxiesLocation;
